import { render, staticRenderFns } from "./splashvideo.vue?vue&type=template&id=5dd76c5c&"
import script from "./splashvideo.vue?vue&type=script&lang=js&"
export * from "./splashvideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports